import ReactDOM from 'react-dom';

// Renders children directly into <body> so popups/overlays always cover the
// full viewport, regardless of transforms/overflow on their parent elements.
export const Portal = ({ children }) => ReactDOM.createPortal(children, document.body);

export default Portal;
